// extracted by mini-css-extract-plugin
export default {"refresh-button":"styles_refresh-button__qSnM+","refreshButton":"styles_refresh-button__qSnM+"};